import { Component } from '@angular/core';

@Component({
	selector: 'qe-privacy-policy-modal',
	templateUrl: './privacy-policy-modal.component.html',
	styleUrls: ['./privacy-policy-modal.component.scss'],
})
export class PrivacyPolicyModalComponent {

	constructor() { }

	scroll(event: Event): void {
		event.preventDefault();
		const hash = (event.target as HTMLAnchorElement).hash.replace('#', '');
		const element = document.getElementById(hash);
		element?.scrollIntoView();
	}
}
